import React from 'react';

export const startIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.308 17">
    <defs>
      <linearGradient id="a" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#ff5e5e" />
        <stop offset="1" stopColor="#ff246e" />
      </linearGradient>
    </defs>
    <path className="a" d="M19.863,9.26H13.852L12.025,3.808a.662.662,0,0,0-1.242,0L8.956,9.26H2.9a.656.656,0,0,0-.654.654.481.481,0,0,0,.012.11.628.628,0,0,0,.274.462l4.941,3.482-1.9,5.513a.656.656,0,0,0,.225.736.632.632,0,0,0,.368.159.8.8,0,0,0,.409-.147L11.4,16.791l4.822,3.437a.766.766,0,0,0,.409.147A.587.587,0,0,0,17,20.216a.648.648,0,0,0,.225-.736l-1.9-5.513,4.9-3.514.119-.1a.686.686,0,0,0,.212-.437A.692.692,0,0,0,19.863,9.26Z" transform="translate(-2.25 -3.375)" />
  </svg>
)

export const emailIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">
<g>
	<g>
		<polygon class="st0" points="339.4,258.6 512,367.7 512,144.9   "/>
	</g>
</g>
<g>
	<g>
		<polygon class="st0" points="0,144.9 0,367.7 172.6,258.6   "/>
	</g>
</g>
<g>
	<g>
		<path class="st0" d="M480,80H32C16,80,3.4,91.9,1,107.2l255,168l255-168C508.6,91.9,496,80,480,80z"/>
	</g>
</g>
<g>
	<g>
		<path class="st0" d="M310.1,278l-45.3,29.8c-2.7,1.8-5.7,2.6-8.8,2.6s-6.1-0.9-8.8-2.6l-45.3-29.9L1,405c2.5,15.2,15.1,27,31,27    h448c15.9,0,28.5-11.8,31-27L310.1,278z"/>
	</g>
</g>
</svg>
  )

export const informationIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 23.6 23.6" space="preserve">

<g>
	<path class="st0" d="M11.8,0C5.3,0,0,5.3,0,11.8s5.3,11.8,11.8,11.8s11.8-5.3,11.8-11.8S18.3,0,11.8,0z M14.3,18.3   c-0.6,0.2-1.1,0.4-1.5,0.5C12.5,19,12,19,11.6,19c-0.7,0-1.3-0.2-1.7-0.5s-0.6-0.8-0.6-1.4c0-0.2,0-0.4,0-0.7   c0-0.2,0.1-0.5,0.1-0.8l0.8-2.7c0.1-0.3,0.1-0.5,0.2-0.7c0-0.2,0.1-0.4,0.1-0.6c0-0.3-0.1-0.6-0.2-0.7c-0.1-0.1-0.4-0.2-0.8-0.2   c-0.2,0-0.4,0-0.6,0.1C8.6,10.9,8.4,11,8.3,11l0.2-0.8C9,10,9.4,9.8,9.9,9.7c0.5-0.1,0.9-0.2,1.3-0.2c0.7,0,1.3,0.2,1.7,0.5   c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.3,0,0.6c0,0.3-0.1,0.6-0.2,0.8l-0.8,2.7c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.3-0.1,0.5-0.1,0.6   c0,0.4,0.1,0.6,0.2,0.7c0.2,0.1,0.4,0.2,0.8,0.2c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.4-0.1,0.5-0.2L14.3,18.3z M14.1,7.4   c-0.4,0.3-0.8,0.5-1.3,0.5c-0.5,0-0.9-0.2-1.3-0.5C11.2,7.1,11,6.7,11,6.2c0-0.5,0.2-0.9,0.5-1.2c0.4-0.3,0.8-0.5,1.3-0.5   c0.5,0,0.9,0.2,1.3,0.5c0.4,0.3,0.5,0.7,0.5,1.2C14.7,6.7,14.5,7.1,14.1,7.4z"/>
</g>
</svg>
)

export const documentIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">

<g>
	<path class="st0" d="M446.6,124.4l-120-120C323.8,1.6,320,0,316,0H106C81.2,0,61,20.2,61,45v422c0,24.8,20.2,45,45,45h300   c24.8,0,45-20.2,45-45V135C451,130.9,449.3,127.1,446.6,124.4z M331,51.2l68.8,68.8H346c-8.3,0-15-6.7-15-15V51.2z M406,482H106   c-8.3,0-15-6.7-15-15V45c0-8.3,6.7-15,15-15h195v75c0,24.8,20.2,45,45,45h75v317C421,475.3,414.3,482,406,482z"/>
	<path class="st0" d="M346,212H166c-8.3,0-15,6.7-15,15s6.7,15,15,15h180c8.3,0,15-6.7,15-15S354.3,212,346,212z"/>
	<path class="st0" d="M346,272H166c-8.3,0-15,6.7-15,15s6.7,15,15,15h180c8.3,0,15-6.7,15-15S354.3,272,346,272z"/>
	<path class="st0" d="M346,332H166c-8.3,0-15,6.7-15,15s6.7,15,15,15h180c8.3,0,15-6.7,15-15S354.3,332,346,332z"/>
	<path class="st0" d="M286,392H166c-8.3,0-15,6.7-15,15s6.7,15,15,15h120c8.3,0,15-6.7,15-15S294.3,392,286,392z"/>
</g>
</svg>
)

export const immigrationIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">

<g>
	<path class="st0" d="M507.8,64.6C507.5,64.3,447.3,7,447.3,7c-2.3-2.2-4.7-4.5-9.1-4.5H196.1c-7.1,0-12.8,5.8-12.8,12.8v39.4   L97.9,69.3c-6.8,1.2-11.4,7.7-10.3,14.6l4.3,25.3c-27.7,9.3-56.2,19-83.7,28.8c-6.5,2.4-9.9,9.6-7.6,16.1l54.7,152   c1.1,3.1,4,5,7.1,5c0.8,0,1.7-0.1,2.5-0.4c3.9-1.4,5.9-5.7,4.5-9.6L15.7,151.3c25.9-9.3,52.7-18.3,78.9-27.2l25.8,150.2l29.7,173   c1.1,6.1,6.4,10.5,12.5,10.5c0.7,0,1.4-0.1,2.1-0.2l80.3-13.8l62.8-10.8l-94.4,33.9l-74.4,26.8L81,333c-1.4-3.9-5.7-5.9-9.6-4.5   c-3.9,1.4-5.9,5.7-4.5,9.6l58.6,163.1c1.9,5.1,6.7,8.3,11.9,8.3c1.4,0,2.9-0.2,4.3-0.8l76.7-27.6l174.1-62.6l33.3-5.7h73.5   c7.1,0,12.8-5.8,12.8-12.9v-327C512,68.6,509.6,66.3,507.8,64.6L507.8,64.6z M487.9,66.4h-37.5l-0.9,0c-1.8,0-6,0-7.1-1   c-0.2-0.2-0.5-1.1-0.5-2.6l-0.1-40.4L487.9,66.4z M497,397.9H198.3V251.7c0-4.1-3.4-7.5-7.5-7.5s-7.5,3.4-7.5,7.5v148.3   c0,7.1,5.8,12.9,12.8,12.9h140.8l-94.5,16.2l-78,13.4l-29.2-170.7L102.9,83.7l80.4-13.8v147c0,4.1,3.4,7.5,7.5,7.5s7.5-3.4,7.5-7.5   V17.5h228.5l0.1,45.3c0,5.5,1.7,9.9,5,13.2c5.1,5,12.2,5.4,16.7,5.4c0.4,0,0.7,0,1.1,0l47.4,0V397.9z"/>
	<path class="st0" d="M234.4,118.9c0,4.1,3.4,7.5,7.5,7.5h214.4c4.1,0,7.5-3.4,7.5-7.5s-3.4-7.5-7.5-7.5H241.9   C237.8,111.4,234.4,114.8,234.4,118.9z"/>
	<path class="st0" d="M456.4,164.7H241.9c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h214.4c4.1,0,7.5-3.4,7.5-7.5   S460.5,164.7,456.4,164.7z"/>
	<path class="st0" d="M456.4,218H241.9c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h214.4c4.1,0,7.5-3.4,7.5-7.5S460.5,218,456.4,218z"/>
	<path class="st0" d="M456.4,271.3H241.9c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h214.4c4.1,0,7.5-3.4,7.5-7.5   S460.5,271.3,456.4,271.3z"/>
	<path class="st0" d="M456.4,324.6H241.9c-4.1,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5h214.4c4.1,0,7.5-3.4,7.5-7.5   S460.5,324.6,456.4,324.6z"/>
</g>
</svg>
)

export const forumsIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">

<g>
	<path class="st0" d="M505.4,150l-18.7-18.7V56c0-16.5-13.5-30-30-30h-220c-16.5,0-30,13.5-30,30v150H55.3c-16.5,0-30,13.5-30,30   v75.3L6.6,330c-4.3,4.3-6.6,9.9-6.6,16s2.3,11.7,6.6,16l18.7,18.7V456c0,16.5,13.5,30,30,30h220c16.5,0,30-13.5,30-30V306h151.5   c16.5,0,30-13.5,30-30v-75.3l18.7-18.7c4.3-4.3,6.6-9.9,6.6-16S509.7,154.3,505.4,150L505.4,150z M285.3,456c0,5.5-4.5,10-10,10   h-220c-5.5,0-10-4.5-10-10v-79.5c0-2.7-1.1-5.2-2.9-7.1l-21.6-21.6c-0.7-0.7-0.8-1.4-0.8-1.9c0-0.4,0.1-1.2,0.8-1.9l21.6-21.6   c1.9-1.9,2.9-4.4,2.9-7.1V236c0-5.5,4.5-10,10-10h151.5v50c0,16.5,13.5,30,30,30h48.5L285.3,456L285.3,456z M491.2,167.9   l-21.6,21.6c-1.9,1.9-2.9,4.4-2.9,7.1V276c0,5.5-4.5,10-10,10h-220c-5.5,0-10-4.5-10-10V56c0-5.5,4.5-10,10-10h220   c5.5,0,10,4.5,10,10v79.5c0,2.7,1.1,5.2,2.9,7.1l21.6,21.6c0.7,0.7,0.8,1.4,0.8,1.9C492,166.4,491.9,167.2,491.2,167.9L491.2,167.9   z"/>
	<path class="st0" d="M416.7,76h-140c-5.5,0-10,4.5-10,10s4.5,10,10,10h140c5.5,0,10-4.5,10-10S422.3,76,416.7,76z"/>
	<path class="st0" d="M416.7,116h-140c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10h140c5.5,0,10-4.5,10-10S422.3,116,416.7,116z"/>
	<path class="st0" d="M416.7,156h-140c-5.5,0-10,4.5-10,10s4.5,10,10,10h140c5.5,0,10-4.5,10-10S422.3,156,416.7,156z"/>
	<path class="st0" d="M416.7,196h-70c-5.5,0-10,4.5-10,10s4.5,10,10,10h70c5.5,0,10-4.5,10-10S422.3,196,416.7,196z"/>
	<path class="st0" d="M416.7,236h-70c-5.5,0-10,4.5-10,10s4.5,10,10,10h70c5.5,0,10-4.5,10-10S422.3,236,416.7,236z"/>
	<path class="st0" d="M95.3,276h70c5.5,0,10-4.5,10-10s-4.5-10-10-10h-70c-5.5,0-10,4.5-10,10S89.7,276,95.3,276z"/>
	<path class="st0" d="M95.3,316h70c5.5,0,10-4.5,10-10s-4.5-10-10-10h-70c-5.5,0-10,4.5-10,10S89.7,316,95.3,316z"/>
	<path class="st0" d="M95.3,336c-5.5,0-10,4.5-10,10s4.5,10,10,10h140c5.5,0,10-4.5,10-10s-4.5-10-10-10H95.3z"/>
	<path class="st0" d="M235.3,376h-140c-5.5,0-10,4.5-10,10s4.5,10,10,10h140c5.5,0,10-4.5,10-10S240.8,376,235.3,376z"/>
	<path class="st0" d="M235.3,416h-140c-5.5,0-10,4.5-10,10s4.5,10,10,10h140c5.5,0,10-4.5,10-10S240.8,416,235.3,416z"/>
</g>
</svg>
)

export const statusIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" id="Bold" enable-background="new 0 0 24 24" viewBox="0 0 24 24"><path d="m.828 13.336c-.261.304-.388.691-.357 1.091s.215.764.52 1.024l7.403 6.346c.275.235.616.361.974.361.044 0 .089-.002.134-.006.405-.036.77-.229 1.028-.542l12.662-15.411c.254-.31.373-.7.334-1.099-.04-.399-.231-.759-.541-1.014l-2.318-1.904c-.639-.524-1.585-.432-2.111.207l-9.745 11.861-3.916-3.355c-.628-.536-1.576-.465-2.115.163z"/></svg>
)

export const adressIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">
<g>
	<g>
		<path d="M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
)

export const phoneIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 384 384" space="preserve">
<g>
	<g>
		<path d="M353.188,252.052c-23.51,0-46.594-3.677-68.469-10.906c-10.719-3.656-23.896-0.302-30.438,6.417l-43.177,32.594    c-50.073-26.729-80.917-57.563-107.281-107.26l31.635-42.052c8.219-8.208,11.167-20.198,7.635-31.448    c-7.26-21.99-10.948-45.063-10.948-68.583C132.146,13.823,118.323,0,101.333,0H30.813C13.823,0,0,13.823,0,30.813    C0,225.563,158.438,384,353.188,384c16.99,0,30.813-13.823,30.813-30.813v-70.323C384,265.875,370.177,252.052,353.188,252.052z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
)

export const contactMailIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" space="preserve">

<g>
	<g>
		<polygon class="st0" points="339.4,258.6 512,367.7 512,144.9   "/>
	</g>
</g>
<g>
	<g>
		<polygon class="st0" points="0,144.9 0,367.7 172.6,258.6   "/>
	</g>
</g>
<g>
	<g>
		<path class="st0" d="M480,80H32C16,80,3.4,91.9,1,107.2l255,168l255-168C508.6,91.9,496,80,480,80z"/>
	</g>
</g>
<g>
	<g>
		<path class="st0" d="M310.1,278l-45.3,29.8c-2.7,1.8-5.7,2.6-8.8,2.6s-6.1-0.9-8.8-2.6l-45.3-29.9L1,405c2.5,15.2,15.1,27,31,27    h448c15.9,0,28.5-11.8,31-27L310.1,278z"/>
	</g>
</g>
</svg>
)